const serviceGroupNoun = (service) => service?.group_metadata?.noun || 'team';

const GroupsService = {
	serviceGroupNoun,
};

export default GroupsService;
